import React, { useState, useEffect } from 'react'
import Row from './elements/Row'
import { TableWrapper } from './componentsStyles'
import { Table_porps } from './interface'

export default function Table({
  activeTable,
  handleRoundId,
  requestBetReply,
  handlePopup,
  prec,
}: Table_porps) {
  const [newdata, setData] = useState(activeTable)

  return (
    <TableWrapper>
      {activeTable.map((el: any, id: number) => (
        <Row
          key={id}
          data={el}
          requestBetReply={requestBetReply}
          handleRoundId={handleRoundId}
          handlePopup={handlePopup}
          prec={prec}
        />
      ))}
    </TableWrapper>
  )
}
